import styled from 'styled-components';

export const Wrapper = styled.div``;

export const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
`;

export const Title = styled.div``;

export const Extra = styled.div``;
